/* =Scroll To js
----------------------------------------------- */
(function ($) {

    // Scrolling content nav
    const header = $('.site-header');
    const scrollNav = $('.scroll-to');
    if (scrollNav.length > 0) {
        const scrollContainer = scrollNav.find('.scroll-to-container');
        const scrollNavMenu = scrollNav.find('.scroll-to-menu');
        // Fix the scroll to nav
        $(window).on('scroll', () => {
            let scrollTop = $(window).scrollTop();
            let scrollUpOddset = (window.innerWidth > 640) ? 134 : 98;
            // If the header is pinned don't unfix nav for an extra 100px
            if (header.hasClass('headroom--pinned')) {
                scrollTop - 100;
            }
            if (scrollTop > scrollNav.offset().top) {
                scrollContainer.addClass('fixed');
            }
            if (scrollTop < scrollNav.offset().top - scrollUpOddset) {
                scrollContainer.removeClass('fixed');
            }
        });

        // Setup scroll to 'slider' for mobile
        scrollNavMenu.slick({
            dots: false,
            arrows: false,
            infinite: false,
            speed: 300,
            slidesToScroll: 3,
            centerMode: false,
            variableWidth: true
        });

        var scrollNavRunning = false;
        // Add smooth scrolling to sections
        const scrollNavAnchor = scrollNavMenu.find('a');
        scrollNavAnchor.on('click', function (e) {
            e.preventDefault();
            $(this).parent().addClass('active');
            scrollNavRunning = true;
            const windowScrollTop = $(window).scrollTop();

            const scrollSection = $(this).parent().data('scroll-to');
            const scrollSectionTop = $(`#${scrollSection}`).offset().top;
            // Check how much space we need above the section
            const offsetPosition = (scrollSectionTop > windowScrollTop) ? 44 : 138;

            $('html, body').animate({
                scrollTop: scrollSectionTop - offsetPosition
            }, 500);
            setTimeout(() => scrollNavRunning = false, 550);
        });

        // Add scroll to menu active classes and focus
        if ($('.scroll-to-section').length > 0) {
            inView.offset(150);
            inView('.scroll-to-section').on('enter', (el) => {
                if (scrollNavRunning) return;

                const scrollToAnchor = scrollNavMenu.find('li[data-scroll-to="' + $(el).attr('id') + '"]');
                const scrollToAnchorLeft = scrollToAnchor.offset().left;
                // Scroll menu item into view?
                scrollToAnchor.addClass('active');
                if (scrollToAnchorLeft < 0 || scrollToAnchorLeft > scrollNav.width()) {
                    scrollNavMenu.slick('slickGoTo', scrollToAnchor.index());
                }
            }).on('exit', (el) => {
                scrollNavMenu.find('li[data-scroll-to="' + $(el).attr('id') + '"]').removeClass('active');
            });
        }
    }

})(jQuery);
